import { createContext, FC, ReactNode, useContext } from 'react';
import useLocalStorageState from '@hooks/useLocalStorageState';
import { LandscapeTabEnum } from '@pages/Home/sections/HomeLandscape/HomeLandscape.constants';

const LANDSCAPE_VIEW_STORAGE_KEY = 'home-landscape-tab';

interface LandscapeViewValue {
    landscapeView: LandscapeTabEnum;
    setLandscapeView: (view: LandscapeTabEnum) => void;
}

const LandscapeViewContext = createContext<LandscapeViewValue | null>(null);

export const LandscapeViewProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [landscapeView, setLandscapeView] = useLocalStorageState<LandscapeTabEnum>(
        LANDSCAPE_VIEW_STORAGE_KEY,
        LandscapeTabEnum.RESTAURANT,
        (raw) =>
            raw === LandscapeTabEnum.ON_SITE ? LandscapeTabEnum.ON_SITE : LandscapeTabEnum.RESTAURANT,
    );

    return (
        <LandscapeViewContext.Provider value={{ landscapeView, setLandscapeView }}>
            {children}
        </LandscapeViewContext.Provider>
    );
};

export function useLandscapeView(): LandscapeViewValue {
    const ctx = useContext(LandscapeViewContext);
    if (ctx === null) {
        throw new Error('useLandscapeView must be used inside LandscapeViewProvider');
    }
    return ctx;
}
